<div class="loading-alert-layer">
  <div class="backdrop" aria-hidden="true"></div>
  <section #dialog class="loading-alert-dialog" role="alertdialog" aria-modal="true" [attr.aria-label]="label() || 'Cargando...'" tabindex="-1">
    <div class="loading" role="progressbar" [attr.aria-label]="label() || 'Cargando...'" aria-busy="true">
      <svg class="loading-svg" viewBox="25 25 50 50" aria-hidden="true">
        <circle class="loading-circle" cx="50" cy="50" r="20" fill="none" stroke-width="3.25" stroke-miterlimit="10" />
      </svg>
    </div>
    @if (label()) {
      <span class="loading-label">{{ label() }}</span>
    }
  </section>
</div>
